interface Params {
  url: string;
  size: number;
}

const getResizedImage = ({ url, size }: Params) => {
  let urlWithoutExt = null;
  let ext = '';

  const picturesRegex = /^(.*\/pictures\/\d\d?\d?)(\..*)?$/;
  const picturesMatch = url.match(picturesRegex);
  if (picturesMatch && picturesMatch[1]) {
    urlWithoutExt = picturesMatch[1];
    ext = picturesMatch[2] || '';
  }

  const uploadsRegex =
    /^(.*\/uploads\/images\/original\/[0-9a-f-]*(?:[^.]*)?)(\..*)?$/;
  const uploadsMatch = url.match(uploadsRegex);
  if (uploadsMatch && uploadsMatch[1]) {
    urlWithoutExt = uploadsMatch[1].replace('/original/', '/resized/');
    ext = uploadsMatch[2] || '';
  }

  const resizeExtensions = ['.jpg', '.jpeg', '.png', '.webp'];

  // skip extensions that should not be resized
  if (!resizeExtensions.includes(ext.toLowerCase())) return url;

  // return resized image
  if (urlWithoutExt) return `${urlWithoutExt}_${size}${ext}`;

  // return original image
  return url;
};

export default getResizedImage;
